import * as React from "react"
import { cn } from "../../lib/utils"

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      aria-hidden
      className={cn(
        "animate-shimmer rounded-md bg-[length:200%_100%]",
        "bg-[linear-gradient(90deg,rgb(255_255_255/0.035)_0%,rgb(255_255_255/0.08)_50%,rgb(255_255_255/0.035)_100%)]",
        className
      )}
      {...props}
    />
  )
}

export { Skeleton }
